/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_My_WorkInputs */

const en_nav_my_work = /** @type {(inputs: Nav_My_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My work`)
};

const de_nav_my_work = /** @type {(inputs: Nav_My_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Arbeit`)
};

/**
* | output |
* | --- |
* | "My work" |
*
* @param {Nav_My_WorkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_my_work = /** @type {((inputs?: Nav_My_WorkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_My_WorkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_my_work(inputs)
	return en_nav_my_work(inputs)
});